import { httpCreate } from './http';

const http = httpCreate('/srv/marketing-sms-task');

export const marketingSmsTask = {
	import(body, params) {
		return http.post('/import', body, { params });
	},
	create(body) {
		return http.post('', body);
	},
	getList(params) {
		return http.get('/list', { params });
	},
	deleteItem(id) {
		return http.delete(`/${id}`);
	},
	getInfoByActivity(activityId) {
		return http.get(`/activity/${activityId}`);
	},
	setInfoByActivity(activityId, body) {
		return http.post(`/activity/${activityId}`, body);
	},
	sendTest(body) {
		return http.post('/sendTest', body);
	},
	getActivityList(activityId, params) {
		return http.get(`/activity/list/${activityId}`, { params });
	},
	editorActivityTask(id, body) {
		return http.put(`/activity/${id}`, body);
	},
	sendNow(id) {
		return http.post(`/send/${id}`);
	},
};
